
import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import basic Swiper styles
import img from "./up.png"; // Ensure the image path is correct
import tata from "./tatam.png";
import figma from "./figma1.png";
import tweet from "./tweet.png";
import "./TopCompanies.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTopCompaniesAsync,
  selectTopCompanies,
} from "./TopCompaniesSlice";
import companylogo from "./logo1png.png"
import { EMPLOYER_COMPANY_LOGO_SAVE_URL } from "../common/URLs";

function TopCompanies() {
  const logos = [img, tata, figma, tweet];

  const dispatch = useDispatch();
  const companies = useSelector(selectTopCompanies);

  useEffect(() => {
    dispatch(fetchTopCompaniesAsync());
    // console.log("companies", companies);
  }, [dispatch])

  return (
    <div className="px-4 sm:max-w-7xl mx-auto ">
      <div className="text-center py-4">
        <p className=" text-4xl font-semibold text-gray-900">
          Current <span className="text-fontBlue"> Opening</span>
        </p>
        <p className="text-black">

          You are the kind of professional that head-hunters are seeking. Find various  post
          from thousands of head-hunters and businesses.
        </p>
      </div>

      <div className="relative h-32 flex items-center justify-center w-full mainpagesliders border-t-2 py-4 mt-4 mb-4 border-b-2">
        <div className="slider-tracks flex w-full items-center">
          {/* Loop through the logos array */}
          {Array.isArray(companies) && companies.length > 0 ? (
            companies.map((company, index) => (
              <div key={index} className="slider-items">
                <img
                  src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                  alt={company.company_name || "Company Logo"}
                  className="h-16 w-auto object-contain"
                  onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
                />
              </div>

            ))
          ) : (
            <div className="text-gray-500 text-center w-full">
              No companies found
            </div>
          )}

          {/* Duplicate logos for a seamless loop */}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
          {companies.map((company, index) => (
            <div key={index} className="slider-items">
              <img
                src={company.logo ? `${EMPLOYER_COMPANY_LOGO_SAVE_URL}${company.logo}` : companylogo}
                alt={company.company_name || "Company Logo"}
                className="h-16 w-auto object-contain"
                onError={(e) => (e.target.src = companylogo)} // Fallback if image fails to load
              />
            </div>
          ))}
        </div>
        <div className="fade-left"></div>
        <div className="fade-right"></div>
      </div>
    </div>
  );
}

export default TopCompanies;